// External
import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import _ from "lodash";

// Internal
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

// Design system
import { IconButton, Dropdown, DropdownMenu } from "@toddle-edu/ds-web";
import { DownloadOutlined } from "@toddle-edu/ds-icons";

// Relative
import { generateFileFromTableData } from "./modules/DownloadTableDataUtils";

const options = [
  {
    key: "CSV",
    label: "Download CSV",
  },
  {
    key: "XLSX",
    label: "Download XLSX",
  },
];

const DownloadTableData = props => {
  const { feedData, columnList, setToastMsg, fileName } = props;

  const handleDownload = ({ key: format }) => {
    // Generate filename with current date in DD_MMM_YYYY format
    const currentDate = _.toLower(moment().format("DD_MMM_YYYY"));
    const fileNameWithDate = `${fileName}_${currentDate}`;

    const result = generateFileFromTableData({
      feedData,
      columnList,
      fileName: fileNameWithDate,
      outputFormat: format,
    });

    if (result.success) {
      setToastMsg({
        msg: `${format} downloaded successfully`,
        type: "success",
      });
    } else {
      setToastMsg({
        msg: `Failed to download ${format}. Please try again.`,
        type: "warning",
      });
    }
  };

  return (
    <Dropdown
      overlay={<DropdownMenu options={options} onClick={handleDownload} />}
    >
      <IconButton
        icon={<DownloadOutlined />}
        variant="neutral"
        type="outlined"
        size="medium"
      />
    </Dropdown>
  );
};

const mapActionCreators = {
  setToastMsg,
};

export default connect(null, mapActionCreators)(DownloadTableData);
